import changePasswordPrompt from "emun.auth/change-password/change-password-prompt";
import chooseRetailerPrompt from "emun.auth/choose-retailer/choose-retailer-prompt";
import acceptVendorTermsPrompt from "emun.auth/accept-vendor-terms-prompt";
import showModePrompt from "emun.showroom/showmode-prompt";
import resolve from "ng";
import SessionBase from "servicestack/session.model";
import modals from "webmodals/modals";
export class Session extends SessionBase {
  constructor() {
    super();
  }

  login(request, forceLocal = false) {
    const session = this;
    session.msg("Logging in...");
    return super.login(request, forceLocal).then((got) =>
      session.bus
        .send("QueryUsers.json?Id=" + session.userAuthId)
        .then((res) => {
          console.info("got users", session.meta.RouteAfterLogin);
          if (
            res.data.results.length &&
            res.data.results[0].meta.ResetPassword
          ) {
            return changePasswordPrompt({
              id: session.userAuthId,
              userAuthId: session.userAuthId,
            });
          } else if (session.hasMultipleBillTos()) {
            return chooseRetailerPrompt({});
          } else if (session.isVendor() && !session.hasAcceptedTerms()) {
            return acceptVendorTermsPrompt({});
          } else {
            resolve("$timeout")(() => {
              if (session.meta.RouteAfterLogin) {
                window.location.href = session.meta.RouteAfterLogin;
              }
              //window.location.reload();
            }, 88);
          }
          return res;
        })
    );
  }

  switchRetailer() {
    const session = this;
    return chooseRetailerPrompt({});
  }

  goShowMode() {
    const session = this;
    return showModePrompt({});
  }

  exitShowMode() {
    const session = this;
    return modals
      .confirm(
        "Please confirm your desire to exit show mode.",
        "Exit Show Mode"
      )
      .result.then(() => {
        return session.bus
          .send("ExitShowMode.json", {
            UserAuthId: session.userAuthId,
          })
          .then((res) => {
            window.location.reload();
          });
      });
  }

  requestOneTimePasscode(
    emailOrUserName,
    { size = "sm", usePrompt = false, login = true } = {}
  ) {
    const session = this;
    // console.debug("requestOneTimePasscode", {
    //   emailOrUserName,
    //   session,
    //   usePrompt,
    //   login,
    // });

    return session.bus
      .send("RequestOneTimePasscode.json?email=" + emailOrUserName)
      .then(({ data: { email, generatedAt } }) => {
        // console.debug("OneTimePasscodeRequested", {
        //   email,
        //   generatedAt,
        //   usePrompt,
        //   login,
        // });
        return usePrompt
          ? session.oneTimePasscodePrompt({
              email,
              login,
              size,
            })
          : { email, generatedAt, login };
      });
  }

  oneTimePasscodePrompt({
    email,
    login = true,
    msg = `Please enter the passcode that was emailed to: ${email}`,
    label = "Passcode",
    okButtonLabel = "Verify",
    size = "sm",
  }) {
    const session = this;
    // console.debug("oneTimePasscodePrompt", {
    //   email,
    //   msg,
    // });

    return modals
      .prompt(msg, "", { label, okButtonLabel, size })
      .result.then((passcode) => {
        // console.debug("AuthenicateOneTimePasscode", passcode);
        return session
          .authenicateOneTimePasscode({ email, login, passcode })
          .catch(() =>
            session.oneTimePasscodePrompt({
              email,
              login,
              msg: "Invalid code, try again, please.",
            })
          );
      });
  }

  authenicateOneTimePasscode({ email, login, passcode }) {
    const session = this;
    // console.debug("AuthenicateOneTimePasscode", {
    //   email,
    //   passcode,
    // });

    return session.bus
      .send("AuthenicateOneTimePasscode.json", {
        email,
        passcode,
        login,
      })
      .then((res) => {
        // console.debug("authenticatedWithPasscode", res);
        if (login) {
          window.location = `/?${passcode}=${email}`;
        }
      });
  }

  impersonateUser(user) {
    const session = this;
    return modals
      .confirm(
        "Please confirm your desire to impersonate this user.",
        user.displayName || user.fullName
      )
      .result.then(() => {
        return session.bus
          .send("ImpersonateUser.json?Id=" + user.id)
          .then((res) => {
            window.location =
              "/?impersonate=" + user.id + "#/impersonate/" + user.id;
          });
      });
  }

  cancelImpersonation() {
    const session = this;
    return modals
      .confirm(
        "Please confirm your desire to return to your original session.",
        "Cancel Impersonation"
      )
      .result.then(() => {
        return session.bus
          .send(
            "CancelImpersonation/" + session.meta.OriginalSessionId + ".json"
          )
          .then((res) => {
            window.location = "/";
          });
      });
  }

  changePassword(request) {
    console.info("request 1", request);
    //this.msg("Changing password...");
    if (!request.id) request.id = this.userAuthId;
    request.userAuthId = request.id;
    console.info("request 2", request);
    return this.bus.send(`ChangePassword.json`, request).then((res) => {
      this.get().then(() => {
        if (this.meta.RouteAfterChangePassword)
          window.location.href = this.meta.RouteAfterChangePassword;
      });
      return res;
    });
  }

  register(request) {
    this.msg("Registering...");
    return this.bus
      .send(`auth/register/${request.role}.json`, request)
      .then((res) => {
        //return window.location.reload(); // fix this later
        if (!request.dontBroadcast) this.$broadcast("$onRegistered", res);
        this.get();
        return res;
      });
  }
}

export default new Session();
